import { Component, OnInit } from '@angular/core';
import { ModalService } from '../modal.service';
import { OrderHistoryService as ColleagueOrderHistoryService } from '@proxy/user-casto/order-history';
import { OrderHistoryService } from 'src/publicproxy/src/proxy/public/order-history';
import { OrderDetailsDto } from '@proxy/dto-common-website/order-history';
import { PrintService } from '../../_services/print.service';
import { Context } from 'src/app/utils/context';
import { GTM } from 'src/app/_services/gtm.service';

@Component({
  selector: 'ng-casto-order-detail',
  templateUrl: './order-detail.component.html'
})
export class OrderDetailComponent implements OnInit {
  orderId: string;
  customerId: string;
  context: Context;

  orderDetail: OrderDetailsDto;
  loading: boolean = false;
  loadingReceiptUrl: boolean = false;

  constructor(
    public modalService: ModalService,
    private orderHistoryService: OrderHistoryService,
    private colleagueOrderHistoryService: ColleagueOrderHistoryService,
    private printService: PrintService,
    private gtm: GTM) { }

  ngOnInit(): void {
    this.orderId = this.modalService.currentDatas.orderId;
    this.customerId = this.modalService.currentDatas.customerId;
    this.context = this.modalService.currentDatas.context;

    switch (this.context) {
      case Context.Colleague:
        this.colleagueOrderHistoryService.getOrderDetails({
          customerId: this.customerId,
          orderId: this.orderId
        }).subscribe(response => {
          this.orderDetail = response;

          this.createBarCode(this.orderDetail!.ticketNumber);
        });
        break;
      case Context.Customer:
        this.orderHistoryService.getOrderDetails({
          customerId: this.customerId,
          orderId: this.orderId
        }).subscribe(response => {
          this.orderDetail = response;
        });
        break;
    }
  }

  print(): void {
    this.gtm.trackInteraction("imprimer_historique",
      this.orderDetail.ticketNumber, { "store_id": this.orderDetail.localisationId });
    const content = document
      .getElementsByTagName('ng-casto-order-detail')
      .item(0) as HTMLElement;

    this.printService.addDom(content);
    this.printService.print();
    this.printService.reset();
  }

  /**
   * Pour le site collègue, le code barre de la commande doit être affiché
   * @param ticketNumber
   * @private
   */
  private createBarCode(ticketNumber: string): void {
    setTimeout(() => {
      const div = document.createElement("div");
      div.innerHTML = this.printService.createBarCode(ticketNumber);
      document.getElementById('barcode').appendChild(div);
    });
  }

  getReceiptUrl(): void {
    if (this.loadingReceiptUrl || !this.orderDetail?.ticketNumber) return;

    this.loadingReceiptUrl = true;

    if (this.context === Context.Colleague) {
      this.colleagueOrderHistoryService.getReceiptUrl({
        customerId: this.customerId,
        orderId: this.orderId
      }).subscribe({
        next: (url) => this.openReceiptUrl(url),
        error: () => this.loadingReceiptUrl = false
      });
    } else {
      this.orderHistoryService.getReceiptUrl({
        customerId: this.customerId,
        orderId: this.orderId
      }).subscribe({
        next: (url) => this.openReceiptUrl(url),
        error: () => this.loadingReceiptUrl = false
      });
    }
  }

  private openReceiptUrl(url: string): void {
    this.loadingReceiptUrl = false;
    window.open(url, `ticket_${this.orderDetail.ticketNumber}`);
  }

  protected readonly Context = Context;
}
